enum PlayableClass {
  Warrior = 1,
  Paladin = 2,
  Hunter = 3,
  Rogue = 4,
  Priest = 5,
  Shaman = 7,
  Mage = 8,
  Warlock = 9,
  Druid = 11
}

export default PlayableClass
